import styled from 'styled-components';
import { spacingMixin } from '@zillow/constellation';

const StyledZillowSpotIllustrations = styled.svg`
  ${spacingMixin}
`;

interface ZillowSpotIllustrationsProps {
  width: string;
  height: string;
}

const ZillowSpotIllustrations = ({ width, height, ...rest }: ZillowSpotIllustrationsProps) => (
  <StyledZillowSpotIllustrations
    width={width}
    height={height}
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M98.6401 122.27C96.9701 120.22 94.3501 109.14 94.3801 106.57C94.4201 102.72 99.5701 95.83 107.13 98.74C109.57 99.68 111.61 103.15 112.61 105.18C114.24 108.51 115.29 114.3 114.12 118.91C113.84 120.03 114.96 121.02 116.15 120.68C118.67 119.97 121.39 119.48 123.58 121.2C125.69 122.86 128.04 128.64 122.91 130.92L98.0801 130.88C97.1401 129.99 96.7901 128.8 96.8001 127.54C96.8101 126.34 97.1601 125.09 97.6701 124C97.9501 123.41 98.2701 122.82 98.6401 122.26V122.27Z"
      fill="#F2A619"
    />
    <path d="M96.7924 39.4182L42.2725 39.3515L42.1607 130.831L96.6806 130.898L96.7924 39.4182Z" fill="#006AFF" />
    <path d="M109.732 39.434L96.792 39.4182L96.6802 130.898L109.62 130.914L109.732 39.434Z" fill="#0D4599" />
    <path d="M57.0446 45.8396L48.7246 45.8295L48.7054 61.5395L57.0254 61.5496L57.0446 45.8396Z" fill="#FFD237" />
    <path d="M73.6843 45.86L65.3643 45.8498L65.3451 61.5598L73.6651 61.57L73.6843 45.86Z" fill="#A6E5FF" />
    <path d="M57.0202 65.2496L48.7002 65.2394L48.681 80.9494L57.001 80.9596L57.0202 65.2496Z" fill="#A6E5FF" />
    <path d="M73.6501 65.2599L65.3301 65.2498L65.3109 80.9597L73.6309 80.9699L73.6501 65.2599Z" fill="#A6E5FF" />
    <path d="M57.0065 84.6496L48.6865 84.6394L48.6673 100.349L56.9873 100.36L57.0065 84.6496Z" fill="#A6E5FF" />
    <path d="M73.6364 84.6699L65.3164 84.6597L65.2972 100.37L73.6172 100.38L73.6364 84.6699Z" fill="#A6E5FF" />
    <path d="M90.3141 45.8803L81.9941 45.8701L81.9749 61.5801L90.2949 61.5903L90.3141 45.8803Z" fill="#A6E5FF" />
    <path d="M90.2907 65.2803L81.9707 65.2701L81.9515 80.9801L90.2715 80.9903L90.2907 65.2803Z" fill="#A6E5FF" />
    <path d="M90.2663 84.6902L81.9463 84.68L81.9271 100.39L90.2471 100.4L90.2663 84.6902Z" fill="#A6E5FF" />
    <path d="M75.4326 120.702L59.7227 120.683L59.7102 130.843L75.4202 130.862L75.4326 120.702Z" fill="#0D4599" />
    <path
      d="M69.3797 110.53C72.7297 110.53 75.4497 114.01 75.4397 118.3V120.7H62.4997L62.8097 115.6L60.6797 116.54L56.9697 110.51H69.3797V110.53Z"
      fill="white"
    />
    <path
      d="M49.5703 118.57V120.67L65.2803 120.69V118.29C65.2803 113.39 60.7103 109.55 55.5503 110.73C52.0203 111.54 49.5803 114.87 49.5803 118.57H49.5703Z"
      fill="#E0F2FF"
    />
    <path d="M96.7879 34.7982L34.8779 34.7226L34.8723 39.3426L96.7822 39.4182L96.7879 34.7982Z" fill="#E0F2FF" />
    <path d="M109.728 34.814L96.7881 34.7982L96.7824 39.4182L109.722 39.434L109.728 34.814Z" fill="#A6E5FF" />
    <path
      d="M32.3792 29.16C31.8692 29.16 31.3992 28.83 31.2492 28.31L27.7192 16.26C27.5392 15.63 27.8992 14.98 28.5192 14.8C29.1392 14.62 29.7992 14.98 29.9792 15.6L33.5092 27.65C33.6892 28.28 33.3292 28.93 32.7092 29.11C32.5992 29.14 32.4892 29.16 32.3792 29.16Z"
      fill="#FFD237"
    />
    <path
      d="M28.1099 32.54C27.9199 32.54 27.7299 32.49 27.5499 32.4L16.5399 26.37C15.9699 26.06 15.7599 25.34 16.0699 24.77C16.3799 24.2 17.0999 23.99 17.6699 24.3L28.6799 30.33C29.2499 30.64 29.4599 31.36 29.1499 31.93C28.9399 32.32 28.5299 32.54 28.1099 32.54Z"
      fill="#FFD237"
    />
    <path
      d="M15.2496 41.43C14.7396 41.43 14.2696 41.1 14.1196 40.58C13.9396 39.95 14.2996 39.3 14.9196 39.12L26.9696 35.59C27.5996 35.41 28.2496 35.77 28.4296 36.39C28.6096 37.02 28.2496 37.67 27.6296 37.85L15.5796 41.38C15.4696 41.41 15.3596 41.43 15.2496 41.43Z"
      fill="#FFD237"
    />
    <path
      d="M49.6499 108.98C49.6199 103.82 45.7199 83.05 36.2599 86.92C33.2099 88.17 30.6399 92.81 29.3899 95.54C26.2399 102.42 24.7799 117.07 32.5699 121.86C36.5499 124.31 42.2399 123.14 45.5699 119.9C48.6099 116.95 49.6699 113.04 49.6499 108.98Z"
      fill="#FFD237"
    />
    <path d="M37.6447 101.101L37.6084 130.831L39.2584 130.833L39.2947 101.103L37.6447 101.101Z" fill="#006AFF" />
  </StyledZillowSpotIllustrations>
);

ZillowSpotIllustrations.defaultProps = {
  width: 244,
  height: 16,
};

export default ZillowSpotIllustrations;
